export default "__VITE_ASSET__DVQ8UZAs__"